import React from 'react';
import Drawer from 'react-modern-drawer';
import 'react-modern-drawer/dist/index.css';
import SetupSection from './SetUpLot';
import LiveLotSetup from '../liveAuction/LiveLotSetup';
import { Triangle } from "react-loader-spinner";

export default function SetUpForMobile({isOpen, setIsOpen,lotData,auctionData,setLotData,priceError, edit, 
    setPriceError,ismdBanner, text, setText, localImages, setLocalImages, oldS3Images, setOldS3Images, loading }){
    return(
        <Drawer
            id="mobile-panel-configuration"
            open={isOpen}
            onClose={()=>setIsOpen((prevState) => !prevState)}
            direction='right'
            className={`bg-[#FFFFFF] mobile-setup ${loading ? 'overflow-hidden' : 'overflow-auto'} pb-[65px] relative
                ${ismdBanner ? 'mt-[68px]' : 'mt-[113px]'}`}
        >
            {auctionData.auction_type=="live" ? 
                <LiveLotSetup 
                    lotData={lotData} edit={edit}
                    auctionData={auctionData}
                    setLotData={setLotData}
                    priceError={priceError}
                    setPriceError={setPriceError}
                    ismdBanner={ismdBanner}
                    localImages={localImages} setLocalImages={setLocalImages}
                    oldS3Images={oldS3Images} setOldS3Images={setOldS3Images} /> 
                : 
                <SetupSection lotData={lotData} edit={edit}
                    auctionData={auctionData}
                    setLotData={setLotData}
                    priceError={priceError}
                    setPriceError={setPriceError}
                    ismdBanner={ismdBanner}
                    localImages={localImages} setLocalImages={setLocalImages}
                    oldS3Images={oldS3Images} setOldS3Images={setOldS3Images}
                />
            }
            {loading && (
                <div className="fixed inset-0 bg-white/70 flex items-center justify-center z-[9999] pointer-events-auto">
                    <Triangle
                        height="60"
                        width="60"
                        color="#000"
                        ariaLabel="triangle-loading"
                        visible={true}
                    />
                </div>
            )}
        </Drawer>
    );
}